import React from "react";
import { Link } from "react-router-dom";
import { Container } from "../layout/Container";
import { useAuth } from "../../auth/AuthContext";
import { logEvent } from "../../utils/analytics";

export function FinalCtaSection() {
  const { isAuthenticated } = useAuth();

  return (
    <section id="cta" className="relative overflow-hidden bg-gradient-to-b from-background-dark via-slate-950 to-background-dark py-24">
      <div className="absolute right-0 top-0 h-full w-1/3 rounded-full bg-primary/15 blur-[120px] animate-pulse" />
      <div className="absolute left-0 bottom-0 h-full w-1/3 rounded-full bg-cyan-500/10 blur-[120px] animate-pulse delay-700" />

      <Container className="relative z-10">
        <div className="relative flex flex-col items-center justify-between gap-12 rounded-2xl border-2 border-primary/30 bg-gradient-to-br from-surface-dark via-surface-dark/95 to-surface-dark p-8 md:flex-row md:p-16 overflow-hidden shadow-2xl shadow-primary/20">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-cyan-500/5" />

          {/* Copy */}
          <div className="relative z-10 flex max-w-xl flex-col gap-4">
            <h2 className="text-3xl font-black leading-tight md:text-5xl text-white">
              Ready to stop{" "}
              <span className="bg-gradient-to-r from-rose-400 to-red-500 bg-clip-text text-transparent">
                overpaying
              </span>
              <br />
              for containers?
            </h2>
            <p className="text-lg text-slate-300 font-medium">
              Start with 10 free simulations. No card. No commitment.
              Or talk to us about embedding the API in your platform.
            </p>
          </div>

          {/* Buttons */}
          <div className="relative z-10 flex w-full flex-wrap gap-4 sm:flex-nowrap md:w-auto">
            <Link
              to={isAuthenticated ? '/console' : '/3d-cargo-load-simulator'}
              onClick={() => logEvent({ name: isAuthenticated ? 'final_cta_open_console' : 'final_cta_start_free', type: 'cta' })}
              className="group flex items-center justify-center gap-2 h-12 whitespace-nowrap rounded-lg bg-gradient-to-r from-primary via-blue-500 to-cyan-500 px-7 font-bold text-white transition-all hover:from-primary/90 hover:via-blue-600 hover:to-cyan-600 hover:scale-105 hover:shadow-xl hover:shadow-primary/50 active:scale-95"
            >
              {isAuthenticated ? 'Open Console' : 'Start free'}
              <span className="material-symbols-outlined text-lg transition-transform group-hover:translate-x-1">arrow_forward</span>
            </Link>
            {isAuthenticated ? (
              <Link
                to="/console?tab=api-keys"
                className="flex h-12 items-center justify-center whitespace-nowrap rounded-lg border-2 border-primary/50 bg-white/5 backdrop-blur-sm px-7 font-bold text-white transition-all hover:border-primary hover:bg-white/10 hover:scale-105 active:scale-95"
              >
                API Keys
              </Link>
            ) : (
              <Link
                to="/developers"
                className="flex h-12 items-center justify-center whitespace-nowrap rounded-lg border-2 border-primary/50 bg-white/5 backdrop-blur-sm px-7 font-bold text-white transition-all hover:border-primary hover:bg-white/10 hover:scale-105 active:scale-95"
              >
                Get the API
              </Link>
            )}
            <Link
              to="/contact-sales"
              onClick={() => logEvent({ name: 'final_cta_contact_sales', type: 'cta' })}
              className="flex h-12 items-center justify-center whitespace-nowrap rounded-lg border border-white/10 bg-white/5 px-6 font-semibold text-slate-300 transition-all hover:text-white hover:bg-white/10 active:scale-95"
            >
              Contact Sales
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
}
